var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin-white",
    d: "M256,0C397.29,0,512,114.71,512,256S397.29,512,256,512,0,397.29,0,256,114.71,0,256,0ZM175.963,399.871V199.95H109.5V399.871Zm239.62,0V285.225c0-61.409-32.787-89.976-76.509-89.976-35.255,0-51.047,19.389-59.889,33.007V199.95H212.738c.881,18.757,0,199.921,0,199.921h66.446V288.221c0-5.976.43-11.95,2.191-16.221,4.8-11.935,15.737-24.3,34.1-24.3,24.034,0,33.663,18.34,33.663,45.2V399.871h66.45ZM143.18,103.55c-22.74,0-37.6,14.95-37.6,34.545,0,19.182,14.4,34.544,36.717,34.544h.429c23.175,0,37.6-15.362,37.6-34.544-.43-19.6-14.424-34.545-37.149-34.545Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinWhite);
export default __webpack_public_path__ + "static/media/linkedin-white.a2e410d3128a3af4b4678c4879b4368c.svg";
export { ForwardRef as ReactComponent };